import { RecipeDetailResponse } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getRecipeDetail } from '../queries/recipe';
import { useAuthStore } from '../stores';
import { RECIPE_QUERY_KEY } from './useGetRecipeList';
import { useInvalidateToken } from './useInvalidateToken';

function preTransformRecipeResponse(
  data: RecipeDetailResponse
): RecipeDetailResponse {
  return {
    ...data,
    ingredient_groups: data.ingredient_groups.map((group) => ({
      ...group,
      ingredients: group.ingredients.map((ig) => ({
        ...ig,
        amount: ig.amount / 1000,
      })),
    })),
  };
}

export function getRecipeDetailOptions(
  productId: string,
  access_token: string,
  invalidateToken: () => void,
  warehouse?: string
) {
  return queryOptions<RecipeDetailResponse>({
    queryKey: [RECIPE_QUERY_KEY, warehouse, productId],
    queryFn: () => getRecipeDetail(productId, access_token, warehouse),
    select: preTransformRecipeResponse,
    staleTime: 10_000,
  });
}

export const useGetRecipeDetail = (productId: string, warehouse?: string) => {
  const token = useAuthStore((s) => s.access_token);
  const invalidateToken = useInvalidateToken([RECIPE_QUERY_KEY]);
  return useQuery(
    getRecipeDetailOptions(productId, token, invalidateToken, warehouse)
  );
};
